import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      minWidth: "100%",
    },
    container: {
      backgroundColor: "#FAFAFA",
      marginBottom: "0.5rem",
    },
    checkBox: {
      paddingTop: "0",
      paddingBottom: "0",
    },
    select: {
      paddingLeft: "0.5rem",
    },
  })
);

export default useStyles;
